var _circle, _path, _rect, _circle2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "#1f2937"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 11 14 Q 11 9 16 9 Q 21 9 21 14",
    fill: "none",
    stroke: "#f3f4f6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 14,
    width: 12,
    height: 9,
    rx: 1.5,
    fill: "#1f2937",
    stroke: "#f3f4f6",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 17.5,
    r: 1.5,
    fill: "#f3f4f6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2,
    y: 19,
    width: 1.6,
    height: 3,
    rx: 0.8,
    fill: "#f3f4f6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.e7cd58400d98073dc20ee877d37fd9c0.svg";
export { ForwardRef as ReactComponent };